import { createSelector } from '@reduxjs/toolkit';

const reportSliceSelector = (state) => state.report || {};

const previewPageSelector = createSelector(
  reportSliceSelector,
  (report) => report.previewPage || {}
);

export { previewPageSelector };
